import disappointingEmoji from './EmojiIcons/disappointingEmoji.svg';
import badEmoji from './EmojiIcons/badEmoji.svg';
import justokEmoji from './EmojiIcons/justokEmoji.svg';
import goodEmoji from './EmojiIcons/goodEmoji.svg';
import excellentEmoji from './EmojiIcons/excellentEmoji.svg';


export const ratingsOption = (Language) => [
    {
        name: Language["Disappointing"],
        rating: 1,
        icon: disappointingEmoji,
    },
    {
        name: Language["Bad"],
        rating: 2,
        icon: badEmoji,
    },
    {
        name: Language["JustOk"],
        rating: 3,
        icon: justokEmoji,
    },
    {
        name: Language["Good"],
        rating: 4,
        icon: goodEmoji,
    },
    {
        name: Language["Excellent"],
        rating: 5,
        icon: excellentEmoji,
    }
]